import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from "mobx";

class HistoryTrackingStore {
  polyLineArray = [];
  count = 0;
  lengthOfPolyLineArray = 0;
  newPolyLineArray = [];
  allArray = [];
  offlineDataNewObj = [];
  offlineData = [];
  historyTrackingTableData = [];
  // histTrackingClickPolylineObj = [];
  tripDataArr = [];
  vehicleTrackingData = [];
  tripCount = 0;
  currentIndex = 0;
  offTripDataArr = [];

  totalCount = 0;
  total = 0;
  postData = {};
  loading = false;
  vehiclesArray = null;
  pgcount = 1;
  offset = 0;
  checked = true;
  rootStore;
  last_record_timestamp = "";

  constructor(rootStore) {
    makeObservable(this, {
      vehiclesArray: observable,
      offlineDataNewObj: observable,
      newPolyLineArray: observable,
      historyTrackingTableData: observable,
      offlineData: observable,
      checked: observable,
      totalCount: observable,
      postData: observable,
      pgcount: observable,
      offset: observable,
      lengthOfPolyLineArray: observable,
      allArray: observable,
      count: observable,
      polyLineArray: observable,
      last_record_timestamp: observable,

      vehicleTrackingData: observable,
      tripDataArr: observable,
      tripCount: observable,
      currentIndex: observable,
      offTripDataArr: observable,
      // histTrackingClickPolylineObj: observable,
      getVehicles: action,
      handleOfflineData: action,
      setOfflineData: action,

      showTripData: action,
      getHistTracDataForTrip: action,
    });

    this.rootStore = rootStore;
  }

  async getHistoryTrackingData(obj) {
    console.log("first", obj);
    // var postData = {
    //   ...obj,
    //   limit: 10,
    //   page: this.pgcount,
    //   offset: this.offset,
    //   tablename: "pmistrack.fm_mt90",
    //   interval: "0",
    //   remaning_vehicleId: "",
    //   last_record_timestamp: this.last_record_timestamp,
    //   vehicleId: [obj.vehicleId],
    //   totalCount: this.totalCount ?? 0,
    // };
    var postData = {
      ...obj,
    };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   // .getClient('report')
    //   .getClient("NodeCoreUrl")
    //   .post("report/historytracking", postData);

    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("/liveTracking/getHistoryTrackingDataCH", postData);

    let arr = await response.data?.data?.vehicleposition;
    this.allArray = await response.data?.data?.vehicleposition;
    this.historyTrackingTableData = await response.data?.data?.vehicleposition;
    this.polyLineArray = await arr.map((val) => [val.latitude, val.longitude]);
    this.lengthOfPolyLineArray = this.polyLineArray.length;
    return this.allArray;

    // let arr = await response?.data?.data?.allData;
    // this.allArray = await response?.data?.data?.startStopData;
    // this.historyTrackingTableData = await response?.data?.data?.startStopData;
    // this.polyLineArray = await arr.map((val) => [val.latitude, val.longitude]);
    // this.lengthOfPolyLineArray = this.polyLineArray.length;

    // return this.allArray;
  }

  async getVehicles(data) {
    // var postData = obj;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/getVehicles", { params: data });
    this.vehiclesArray = response.data?.vehicleData;
    // this.vehiclesArray = response?.data?.data;
  }

  // async offlineData(obj){
  //   var postData ={...obj,"offset":0,"limit":10,"page":1} ;
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi.getClient().post("index.php?c=vehicle&a=offlinedata", "postData=" + base64Input);

  // }

  async setOfflineData(data) {
    // this.vehicleId = data.vehicleId;
    var postData = {
      ...data,
      limit: 10,
      page: this.pgcount,
      offset: this.offset,
      tablename: "pmistrack.fm_mt90",
      interval: "0",
      remaning_vehicleId: "",
      last_record_timestamp: this.last_record_timestamp,
      vehicleId: [data.vehicleId],
      totalCount: this.totalCount ?? 0,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      // .getClient('report')
      .getClient("NodeCoreUrl")
      .post("/liveTracking/getHistoryTrackingDataCH", postData);

    this.postData = data;

    let totalCount = response?.data?.data?.totalcount;

    // this.allArray = await response?.data?.data?.startStopData;

    this.offlineData = response?.data?.data;

    // if (response?.data?.data?.last_record_timestamp) {
    //   this.last_record_timestamp = response?.data?.data?.last_record_timestamp;
    // }
    console.log(this.checked, "this.checked");
    if (this.checked) {
      if (this.totalCount === null) {
        this.totalCount = totalCount;
      }

      if (
        this.totalCount >= 10 ||
        (this.totalCount < 10 && this.totalCount >= 0)
      ) {
        if (await this.offlineData?.vehicleposition) {
          await this.offlineData?.vehicleposition?.forEach((val) => {
            // this.offlineLatLongArray.push(val);
            console.log(val);
            this.offlineDataNewObj.push(val);
          });

          await this.handleOfflineData();
        }
      } else if (this.totalCount === 0) {
        console.log("end");
      }
    }

    return response?.data?.data;
  }

  async handleOfflineData() {
    this.totalCount = this.totalCount - 10;
    this.pgcount = ++this.pgcount;
    this.offset = this.offset + 10;
    this.setOfflineData(this.postData);
  }

  async showTripData(data) {
    console.log("showTripData", data);
    var postData = {
      ...data,
      limit: 10,
      page: this.pgcount,
      offset: this.offset,
      tablename: "pmistrack.fm_mt90",
      interval: "0",
      remaning_vehicleId: "",
      last_record_timestamp: this.last_record_timestamp,
      vehicleId: [data.vehicleId],
      totalCount: this.totalCount ?? 0,
      TripEventdata: 2,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      //.getClient()
      //.post("index.php?c=vehicle&a=startstop", "postData=" + base64Input);
      .getClient("NodeCoreUrl")
      .post("report/travelreportnew", postData);

    this.tripDataArr = response?.data?.data?.startStopData;
    this.tripCount = response?.data?.data?.TotalCount;
    return response?.data?.data?.startStopData;
  }

  async getHistTracDataForTrip(obj) {
    var postData = obj;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicletracking&a=getHistoryTrackingData",
        "postData=" + base64Input
      );

    this.vehicleTrackingData = response.data.data.vehicleposition;

    return response.data.data.vehicleposition;
  }
}

export default HistoryTrackingStore;
